import { Icon } from '@mui/material';
import styled from 'styled-components';

const IconStyled = styled(Icon)`
	margin: ${props => props.margin};
	color: ${props => (props.color ? props.color : props.theme.icon.color)};
`;

export default IconStyled;
